import React, { Component } from 'react';
import Select from 'react-select';
import { GetPOAndLineItemListForDispatchForDCListing, postDispatchClearenceDetails, postSubmitInvoiceDetails } from '../store/actions/dispatchOrderDetailsActions';
import { getProjectAllocationByUserId } from '../store/actions/poDetailsActions';
import { connect } from 'react-redux'
import swal from 'sweetalert';
import env from '../ENV';
import toast from 'react-hot-toast';
import AuthHandler from '../Classes/AuthHandler';
import CurrencyInput from 'react-currency-input-field';
import { Link } from 'react-router-dom';
import Modal from '../Components/CustomModal';
import ModalHeader from '../Components/ModalHeader';
import ModalBody from '../Components/ModalBody';
import ModalFooter from '../Components/ModalFooter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FileVersionModal from '../Components/FileVersionModal';
import { GenericUploadVersionFile } from '../store/actions/fileActions';
// import { CSVLink } from "react-csv";
import SearchBar from '../Components/SearchBar';
import { Form, Button, InputGroup, FormControl, Card } from 'react-bootstrap';
import { GetFilterList } from '../store/actions/masterActions'

const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

class DispatchVendorDocumentSubmission extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dispatch_data: [],
            selected: [],
            tabledata: [],
            tabledata1: [],
            dropDownArray: [],
            checkedArray: [],
            select: false,
            TotalInvoiceVal: 0,
            selectedPoId: 0,
            selectedPOSAPId: "",
            VendorState: "",
            VendorCountry: "",
            modal: false,
            reviseForm: {
                file: [],
                comment: ""
            },
            uploadedId: "",
            prevValue: 0,
            filterByPOSAPId: [],
            filterByVendorName: [],
            csvData: [],
            searchForOptions: [
                { label: 'Plant Code', value: 'Plant Code' },
                { label: 'PO Number', value: 'PO Number' },
                { label: 'Vendor', value: 'Vendor' },
                { label: 'Project No.', value: 'WBS' },
            ],
            isShowFilter: false,
            finalvendorlist: [],
            finalpos: [],
            finalwbsno: [],
            finalplantcode: [],
            PlantCode: [],
            WBSCode: [],
            POSAPId: [],
            VendorName: [],
            sortByPlantCode: [],
            sortByWBS: [],
            sortByPo: [],
            sortByVendor: [],
            searchTerm: '',
            searchFor: '',
            searchForItem: [],
        };
    }

    componentDidMount = async() => {
        let roles = AuthHandler.getRoles()
        let userId = AuthHandler.getUserID()
        if (roles[12]) {
            let sortByWBS = []
            let WBSCode = []
            await this.props.getProjectAllocationByUserId({ UserId: userId })
            let ProjectCodes = await this.props.poDetails.getProjectAllocationByUserId
            if (ProjectCodes.length > 0) {
                ProjectCodes.map((elem) => {
                    sortByWBS.push(elem.ProjectCode)
                    WBSCode.push({ label: elem.ProjectCode, value: elem.ProjectCode })
                })
            }
            await this.setState({ sortByWBS, WBSCode })
        }
        await this.dataSync()
        await this.getFilterList()
    }
    dataSync = async () => {
        var roles = AuthHandler.getRoles()
        if (roles[5]) {
            let searchdata = {
                userId: AuthHandler.getUserID(),
                filterByPOSAPId: this.state.sortByPo,
                filterByVendorName: this.state.sortByVendor,
                sortByPlantCode: this.state.sortByPlantCode,
                sortByWBS: this.state.sortByWBS,
                searchTerm: '',
                searchFor: '',
                roleId:roles
            }
            await this.props.GetPOAndLineItemListForDispatchForDCListing(searchdata)
        } else {
            let searchdata = {
                userId: 0,
                filterByPOSAPId: this.state.sortByPo,
                filterByVendorName: this.state.sortByVendor,
                sortByPlantCode: this.state.sortByPlantCode,
                sortByWBS: this.state.sortByWBS,
                searchTerm: this.state.searchTerm,
                searchFor: this.state.searchFor,
                // roleId:roles
            }
            await this.props.GetPOAndLineItemListForDispatchForDCListing(searchdata)
        }
        let dropDownArray = []
        let uniqueTableData = await this.props.dispatchOrderDetailsReducer.getPOAndLineItemListForDispatchForDCListing.recordset.filter((data) => data.Issued == 2)
        const tabledata = uniqueTableData.filter((item, index, self) =>
            index === self.findIndex((t) => (
                t.id === item.id && t.DCIssuedId === item.DCIssuedId // Adjust the comparison based on your object's properties
            ))
        );
        await tabledata.map((data) => {
            if (dropDownArray.filter(item => item.value == data.PurchaseOrderId).length == 0) {
                dropDownArray.push({ label: data.POSAPId, value: data.PurchaseOrderId })
            }
        })
        // console.log(dropDownArray, "daadaa")
        let csvData = []
        // await tabledata.map((item) => {
        //     csvData.push({
        //         "PO No": item.POSAPId,
        //         "PO Line Item No": item.POLineItemSAPCode,
        //         "Issued qty": item.IssuedQunatity,
        //         "Qty Already Dispatched": item.AlreadyDispatched,
        //         "Customer BillingSchedule No.": item.BillingScheduleNo,
        //         "Customer BillingSchedule Description": item.BillScheduleDescription,
        //         //  "Present Dispatch": ,
        //         //  "Remaining": ,
        //         //  "Total Value": ,
        //     })
        // })

        await this.setState({ tabledata, dropDownArray, csvData })
        // console.log(this.state.tabledata,"this.state.tabledata")
    }
    handleSingleCheckBoxChange = (item) => {
        var checkedArray = [...this.state.checkedArray]
        var TotalInvoiceVal = this.state.TotalInvoiceVal
        if (!checkedArray.includes(item)) {
            checkedArray.push(item)
            TotalInvoiceVal = TotalInvoiceVal + (this.state.tabledata.find(data => data.DCIssuedId == item).NetPrice * this.state.tabledata.find(data => data.DCIssuedId == item).RequestedQuantityForVendors)
            console.log("TotalInvoiceVal", TotalInvoiceVal)
        } else {
            checkedArray = checkedArray.filter(item => item !== item)
        }
        this.setState({ checkedArray, TotalInvoiceVal });
    };
    handleChange = async () => {
        let select = !this.state.select;
        var checkedArray = []
        var TotalInvoiceVal = 0
        await this.state.tabledata1.map((item) => {
            if (select == true && item.InvoiceId == null && item.AlreadyDispatched != item.IssuedQunatity) {
                TotalInvoiceVal = TotalInvoiceVal + (item.NetPrice * item.RequestedQuantity)
                checkedArray.push(item.DCIssuedId)
            }
        })
        await this.setState({ select: select, checkedArray, TotalInvoiceVal });
    };
    handleSelectPOs = async (e) => {
        let selectedPoId = e.value
        let selectedPOSAPId = e.label
        let tabledata1 = [...this.state.tabledata]
        tabledata1 = tabledata1.filter((dataitem) => dataitem.PurchaseOrderId == selectedPoId)
        let vendorName = tabledata1[0].VendorName
        let VendorState = tabledata1[0].VendorState
        let VendorCountry = tabledata1[0].VendorCountry
        console.log("tabledata1", tabledata1)
        await this.setState({ selectedPoId, tabledata1, vendorName, VendorState, VendorCountry, selectedPOSAPId })
    }
    handlePDCInput = async (e, index, indicator) => {
        let input = e.target.value
        let balanceQuant = this.state.tabledata1[index].AlreadyDispatched == 0 ? this.state.tabledata1[index].IssuedQunatity - 0 : parseFloat(this.state.tabledata1[index].IssuedQunatity) - parseFloat(this.state.tabledata1[index].AlreadyDispatched)
        if (parseFloat(input) > parseFloat(balanceQuant).toFixed(2)) {
            swal("Please enter valid quantity", { icon: "error" })
            let tabledata1 = [...this.state.tabledata1]
            tabledata1[index].RequestedQuantityForVendors = ""
            await this.setState({ tabledata1 })
            return false
        } else {
            let tabledata1 = [...this.state.tabledata1]
            let TotalInvoiceVal = 0
            tabledata1[index].RequestedQuantityForVendors = input
            tabledata1[index].remaining = balanceQuant - input
            this.state.checkedArray.map((elem) => {
                TotalInvoiceVal = TotalInvoiceVal + (tabledata1.find(data => data.DCIssuedId == elem).NetPrice * tabledata1.find(data => data.DCIssuedId == elem).RequestedQuantityForVendors)
            })
            await this.setState({ tabledata1, TotalInvoiceVal })
        }
    }
    
    SubmitInvoice = async () => {
        let input = {}
        let addDCValue = []
        if (this.state.selectedPoId == 0) {
            swal("Please Select A PO First", { icon: "error" })
            return false
        }
        if (this.state.checkedArray.length == 0) {
            swal("Please Select A Line Item First", { icon: "error" })
            return false
        }
        for (let i = 0; i < this.state.checkedArray.length; i++) {
            if (this.state.tabledata.find(elem => elem.DCIssuedId == this.state.checkedArray[i]).RequestedQuantityForVendors == 0) {
                swal(`You can not dispatch 0 quantity for PO - ${this.state.tabledata.find(elem => elem.DCIssuedId == this.state.checkedArray[i]).POSAPId} and LineItem - ${this.state.tabledata.find(elem => elem.DCIssuedId == this.state.checkedArray[i]).POLineItemSAPCode}`, { icon: "error" })
                return false
            }
        }
        this.state.checkedArray.map(elem => {
            addDCValue.push({
                DCId: elem,
                DcQuantity: this.state.tabledata.find(data => data.DCIssuedId == elem).RequestedQuantityForVendors
            })
        })
        console.log("addDcValue", addDCValue)
        this.state.checkedArray.map(async (data) => {
            let templatedata = {
                DCIssuedId: data,
                indicator: 8,
                RequestedQuantity: this.state.tabledata1.find(itemData => itemData.DCIssuedId == data).RequestedQuantityForVendors
            }
            await this.props.postDispatchClearenceDetails(templatedata)
        })
        input = {
            poId: this.state.tabledata1[0].PurchaseOrderId,
            addDCValue: addDCValue,
            PaymentType: this.state.tabledata1[0].PaymentTypeId,
            TypeFor: this.state.tabledata1[0].TypeFor,
            InvoiceAmount: this.state.TotalInvoiceVal
        }
        console.log("input", input)
        await this.props.postSubmitInvoiceDetails(input)
        await this.setState({ TotalInvoiceVal: 0 })
        await this.props.history.push({ pathname: '/PoAcceptanceTrail', state: { poId: this.state.selectedPoId, poSAPId: this.state.selectedPOSAPId } })
    }
    billhandleChange = async (e, index, val) => {
        let input = e.target.value
        if (val == 2) {
            let tabledata1 = [...this.state.tabledata1]
            tabledata1[index].BillingScheduleNo = input
            await this.setState({ tabledata1 })
        } else if (val == 1) {
            let tabledata = [...this.state.tabledata]
            tabledata[index].BillingScheduleNo = input
            await this.setState({ tabledata })
        }
    }
    billDeschanldeChange = async (e, index, val) => {
        let input = e.target.value
        if (val == 2) {
            let tabledata1 = [...this.state.tabledata1]
            tabledata1[index].BillScheduleDescription = input
            await this.setState({ tabledata1 })
        } else if (val == 1) {
            let tabledata = [...this.state.tabledata]
            tabledata[index].BillScheduleDescription = input
            await this.setState({ tabledata })
        }
        console.log(e.target.value)
    }
    handleCustomerPo = async (e, index, val) => {
        let input = e.target.value
        if (val == 2) {
            let tabledata1 = [...this.state.tabledata1]
            tabledata1[index].Customer_PO = input
            await this.setState({ tabledata1 })
        } else if (val == 1) {
            let tabledata = [...this.state.tabledata]
            tabledata[index].Customer_PO = input
            await this.setState({ tabledata })
        }
    }
    handleVendorName = async (e, index, val) => {
        let input = e.target.value
        if (val == 2) {
            let tabledata1 = [...this.state.tabledata1]
            tabledata1[index].VendorName = input
            await this.setState({ tabledata1 })
        } else if (val == 1) {
            let tabledata = [...this.state.tabledata]
            tabledata[index].VendorName = input
            await this.setState({ tabledata })
        }
    }
    handleVendorPONo = async (e, index, val) => {
        let input = e.target.value
        if (val == 2) {
            let tabledata1 = [...this.state.tabledata1]
            tabledata1[index].VendorPONo = input
            await this.setState({ tabledata1 })
        } else if (val == 1) {
            let tabledata = [...this.state.tabledata]
            tabledata[index].VendorPONo = input
            await this.setState({ tabledata })
        }
    }
    hanldeVendorPOLineItemNo = async (e, index, val) => {
        let input = e.target.value
        if (val == 2) {
            let tabledata1 = [...this.state.tabledata1]
            tabledata1[index].VendorPO_Line_Item_No = input
            await this.setState({ tabledata1 })
        } else if (val == 1) {
            let tabledata = [...this.state.tabledata]
            tabledata[index].VendorPO_Line_Item_No = input
            await this.setState({ tabledata })
        }
    }
    hanldeCustomerBillingScheduleQuantity = async (e, index, val) => {
        let input = e.target.value
        if (val == 2) {
            let tabledata1 = [...this.state.tabledata1]
            tabledata1[index].Customer_Billing_Schedule_Quantity = input
            await this.setState({ tabledata1 })
        } else if (val == 1) {
            let tabledata = [...this.state.tabledata]
            tabledata[index].Customer_Billing_Schedule_Quantity = input
            await this.setState({ tabledata })
        }
    }
    hanldeUOM = async (e, index, val) => {
        let input = e.target.value
        if (val == 2) {
            let tabledata1 = [...this.state.tabledata1]
            tabledata1[index].UOM = input
            await this.setState({ tabledata1 })
        } else if (val == 1) {
            let tabledata = [...this.state.tabledata]
            tabledata[index].UOM = input
            await this.setState({ tabledata })
        }
    }
    hanldeRemarks = async (e, index, val) => {
        let input = e.target.value
        if (val == 2) {
            let tabledata1 = [...this.state.tabledata1]
            tabledata1[index].Remarks = input
            await this.setState({ tabledata1 })
        } else if (val == 1) {
            let tabledata = [...this.state.tabledata]
            tabledata[index].Remarks = input
            await this.setState({ tabledata })
        }
    }
    QuantityChange = async (e, index, val) => {
        let input = e.target.value
        if (val == 2) {
            let tabledata1 = [...this.state.tabledata1]
            let prevValue = tabledata1[index].IssuedQunatity
            tabledata1[index].IssuedQunatity = input
            await this.setState({ tabledata1, prevValue })
        } else if (val == 1) {
            let tabledata = [...this.state.tabledata]
            let prevValue = tabledata[index].IssuedQunatity
            tabledata[index].IssuedQunatity = input
            await this.setState({ tabledata, prevValue })
        }
    }
    handleSaveBillingScheduleDetails = async (item, indicator) => {
        let templatedata = {}
        if (indicator == 2) {
            templatedata = {
                RequestedQuantity: 0,
                PoLineItemId: 0,
                indicator: indicator,
                issuedQuantity: 0,
                BillingSchNo: item.BillingScheduleNo,
                BillingSchDescription: "",
                DCIssuedId: item.DCIssuedId
            }
        } else {
            templatedata = {
                RequestedQuantity: 0,
                PoLineItemId: 0,
                indicator: indicator,
                issuedQuantity: 0,
                BillingSchNo: "",
                BillingSchDescription: item.BillScheduleDescription,
                DCIssuedId: item.DCIssuedId,
                CustomerPo : item.Customer_PO,
                VendorName : item.VendorName,
                VendorPONo : item.VendorPONo,
                VendorPOLineItemNo : item.VendorPO_Line_Item_No,
                CustomerBillingScheduleQuantity : item.Customer_Billing_Schedule_Quantity,
                UOM : item.UOM,
                Remarks : item.Remarks,
            }
        }

        await this.props.postDispatchClearenceDetails(templatedata)
        await toast.success(`Data has been saved`, {
            duration: 1000
        });
    }
    handleSaveQuantityDetails = async (item, indicator) => {
        let data = this.state.tabledata.filter(elem => elem.PoLineItemId == item.PoLineItemId)
        let IssuedQunatity = data.reduce((accumulator, current) => accumulator + parseFloat(current.IssuedQunatity, 2), 0);
        console.log("IssuedQunatity", IssuedQunatity)
        if (item.IssuedQunatity < item.AlreadyDispatched || item.IssuedQunatity > item.IcQuantity || item.IcQuantity < IssuedQunatity) {
            swal("Please enter valid quantity", { icon: "error" })
            if (indicator == 1) {
                let tabledata1 = [...this.state.tabledata1]
                let findindex = tabledata1.findIndex((el) => el.DCIssuedId == item.DCIssuedId && el.PurchaseOrderLineId == item.PurchaseOrderLineId)
                if (findindex != -1) {
                    tabledata1[findindex].IssuedQunatity = this.state.prevValue
                    await this.setState({ tabledata1 })
                }
                console.log('tabledata1', tabledata1, findindex)
            }
            await this.dataSync()
            return false
        }
        let templatedata = {
            RequestedQuantity: 0,
            PoLineItemId: item.PoLineItemId,
            indicator: indicator,
            issuedQuantity: item.IssuedQunatity,
            BillingSchNo: "",
            BillingSchDescription: "",
            DCIssuedId: item.DCIssuedId
        }
        await this.props.postDispatchClearenceDetails(templatedata)
    }
    modal = async (uploadedId) => {
        await this.setState({ modal: !this.state.modal });
        if (this.state.modal == true) {
            this.setState(
                { opacity: "", uploadedId }
            )
        }
        else {
            this.setState(
                { opacity: "0.2" }
            )
        }
    }
    // ? open version modal
    OpenVersionModal = async (uploadedId) => {
        let versionList = [];
        console.log(uploadedId, "this.state.uploadID")
        let stateVal = this.state.OpenVersionModal;
        this.setState({ OpenVersionModal: !stateVal, uploadedId: uploadedId });
    }
    handleFileInput = async (event) => {
        let reviseForm = this.state.reviseForm
        reviseForm.file.push(event.target.files[0])
        this.setState({ reviseForm });
    }
    reviseDc = async () => {
        await this.props.GenericUploadVersionFile(this.state.reviseForm.file, this.state.uploadedId, "", AuthHandler.getUserID());
        await this.dataSync()
        await this.modal()
        await toast.success(`DC Updated`, {
            duration: 2000
        });
    }
    // ? handle search input
    handleISearch = (e) => {
        let searchTerm = e.target.value
        this.setState({
            searchTerm
        })
        console.log(this.state.searchTerm)
    }
    // ? handle searching
    handleSearching = async () => {
        await this.dataSync()
    }
    toggleFilter = async () => {
        this.setState({ isShowFilter: !this.state.isShowFilter })
    }
    getFilterList = async () => {
        await this.props.GetFilterList()
        let finalvendorlist = []
        let finalpos = []
        let finalwbsno = []
        let finalplantcode = []
        await this.props.filterList[1].map(async (item) => {
            await finalplantcode.push({ label: item.PlantCode, value: item.PlantCode })
        })
        await this.props.filterList[2].map(async (item) => {
            await finalwbsno.push({ label: item.WBSCode, value: item.WBSCode })
        })
        await this.props.filterList[3].map(async (item) => {
            await finalvendorlist.push({ label: item.VendorName, value: item.VendorName })
        })
        await this.props.filterList[4].map(async (item) => {
            await finalpos.push({ label: item.POSAPId, value: item.POSAPId })
        })

        let POSAPId = []
        let WBSCode = []
        let PlantCode = []
        let VendorName = []
        await this.state.sortByPlantCode.map(async (item) => {
            await PlantCode.push({ label: item, value: item })
        })
        await this.state.sortByWBS.map(async (item) => {
            await WBSCode.push({ label: item, value: item })
        })
        await this.state.sortByPo.map(async (item) => {
            await POSAPId.push({ label: item, value: item })
        })
        await this.state.sortByVendor.map(async (item) => {
            await VendorName.push({ label: item, value: item })
        })
        await this.setState({ finalvendorlist, finalpos, finalwbsno, finalplantcode, PlantCode, WBSCode, POSAPId, VendorName })
    }
    handleSelectSearchFor = async (value) => {
        let searchFor = value
        let searchForItem = [
          {
            label: value, value: value
          }
        ]
        await this.setState({ searchFor, searchForItem })
      }
    handleSelectWBS = async (e) => {
        let sortByWBS = []
        let WBSCode = []
        if (e.length > 0) {
            e.map((item) => {
                sortByWBS.push(item.value)
                WBSCode.push(item)
            })
        }
        await this.setState({ sortByWBS, WBSCode })
        await this.dataSync()
    }
    handleSelectVendor = async (e) => {
        let sortByVendor = []
        let VendorName = []
        if (e.length > 0) {
            e.map((item) => {
                sortByVendor.push(item.value)
                VendorName.push(item)
            })
        }
        await this.setState({ sortByVendor, VendorName })
        await this.dataSync()
    }
    handleSelectPlantCode = async (e) => {
        let sortByPlantCode = []
        let PlantCode = []
        if (e.length > 0) {
            e.map((item) => {
                sortByPlantCode.push(item.value)
                PlantCode.push(item)
            })
        }
        await this.setState({ sortByPlantCode, PlantCode })
        await this.dataSync()
    }
    clearFilter = async () => {
        await this.setState({
            isShowFilter: false,
            PlantCode: [],
            WBSCode: [],
            POSAPId: [],
            VendorName: [],
            sortByPlantCode: [],
            sortByWBS: [],
            sortByPo: [],
            sortByVendor: [],
            searchTerm: '',
            searchFor: '',
            searchForItem: [],
        })
        await this.dataSync()
    }
    render() {
        console.log("findingFromReportsData", AuthHandler.getUserID())
        var roles = AuthHandler.getRoles()
        const customStyles = {
            option: (provided, state) => ({
                ...provided,
                borderBottom: '1px dotted pink',
                //   color: state.isSelected ? 'red' : 'blue',
                padding: "2px 10px",
            }),
            menu: (provided, state) => ({
                ...provided,
                width: "100%",
                minWidth: "max-content",
                zIndex: "999 !important",
            }),
        }
        return (
            <div className="mt-2">
                {/*----------File version start  */}
                {this.state.uploadedId && this.state.OpenVersionModal && <FileVersionModal uploadedId={this.state.uploadedId} OpenVersionModal={(uploadId) => this.OpenVersionModal(uploadId)} />}
                {/*----------File version end  */}
                <Modal isOpen={this.state.modal} className="modal-lg">
                    <div className="modalheads">
                        <ModalHeader HeaderStyle="modal-header ">
                            <div className="modal-text"><h4>Upload Documents</h4></div>
                            <button type="button" className="close" aria-label="Close" onClick={this.modal} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </ModalHeader>
                    </div>
                    <ModalBody Style="modal-body ">
                        <div className="row mt-4">
                            <div className="col-md-6">Dispatch Clearence:</div>
                            <div className="col-md-6"><input id="FileDispatch" type="file" onChange={(e) => this.handleFileInput(e)} className="form-control-file" /></div>
                        </div>
                    </ModalBody>
                    <div className="">
                        <ModalFooter FooterStyle="modal-footer ">
                            <div>
                                <button className="btn2 btn-sms1 mt-2 ml-2 float-right rounded-pill" type="submit" onClick={() => this.reviseDc()}>Submit</button>
                                <button className="btn2 btn-sms1 mt-2 ml-2 rounded-pill" onClick={this.modal} type="submit">Close</button>
                            </div>
                        </ModalFooter>
                    </div>
                </Modal>
                <div className="mx-auto">
                    <div className="ml-3" style={{ marginRight: '2rem' }}>
                        <div className="row">
                            <div className="col-md-2 header">
                                <b>Issued DC List</b>
                            </div>
                            <div className="col-md-10">
                                <div className='row mt-3'>
                                    {roles[5] || roles[7] ?
                                        <>
                                            <div className='col-1.5'>
                                                <b><label htmlFor="exampleInputEmail1" className="form-label">PO Number:</label></b>
                                            </div>
                                            <div className='col-2'>
                                                <Select maxMenuHeight={500} placeholder="Purchase Orders" value={{ label: this.state.selectedPOSAPId }} styles={customStyles} options={this.state.dropDownArray} onChange={(e) => this.handleSelectPOs(e)} />
                                            </div>
                                            <div className='col'>
                                                <b><label htmlFor="exampleInputEmail1" className="form-label">Total Invoice Value:</label></b>
                                            </div>
                                            <div className='col'>
                                                <CurrencyInput allowNegativeValue={false} decimalScale="2" className="form-control text-center" value={this.state.TotalInvoiceVal} readOnly />
                                            </div>
                                            <div className='col'>
                                                <button type="submit" className="btn2 btn-sms1 rounded-pill" onClick={() => this.SubmitInvoice()}>Submit Invoice</button>
                                            </div>
                                            {/* <div className='col'>
                                                <CSVLink className="btn2 btn-sms1 rounded-pill" data={this.state.csvData} filename='Dispatch'>export</CSVLink>
                                            </div> */}
                                        </>
                                        :
                                        <>
                                            {/* <div className='col-6'>
                                                <CSVLink className="btn2 btn-sms1 rounded-pill float-right" data={this.state.csvData} filename='Dispatch'>export</CSVLink>
                                            </div> */}
                                            <div className='col mr-4'>
                                                <SearchBar placeholder="Search" value={this.state.searchTerm} searchInputHandler={(e) => { this.handleISearch(e) }} searchClick={this.handleSearching} label="Search" toggleFilter={this.toggleFilter} clearFilter={this.clearFilter} filter={true} clear={true} btnName="" ShowSearchFor={true} searchForOptions={this.state.searchForOptions} searchForItem={this.state.searchForItem} SelectSearchForHandler={this.handleSelectSearchFor} />
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                        {this.state.isShowFilter ?
                            <div className="row justify-content-between pb-3 pt-3 m-0 border-radius-modal filter-data pr-2 pl-2">
                                <div className="col">
                                    <Select maxMenuHeight={500} placeholder="Project No." isMulti value={this.state.WBSCode} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalwbsno} onChange={(e) => this.handleSelectWBS(e)} />
                                </div>
                                <div className="col">
                                    <Select maxMenuHeight={500} placeholder="Vendor" isMulti value={this.state.VendorName} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalvendorlist} onChange={(e) => this.handleSelectVendor(e)} />
                                </div>
                                <div className="col">
                                    <Select maxMenuHeight={500} placeholder="Plant" isMulti value={this.state.PlantCode} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalplantcode} onChange={(e) => this.handleSelectPlantCode(e)} />
                                </div>
                            </div>
                            : null}
                    </div>
                    <table className="table table-bordered mt-4">
                        <thead className="table-primary" style={{ backgroundColor: "#0989CB", color: "white" }}>
                            <tr>
                                {roles[5] || roles[7] && this.state.tabledata1.length > 0 ?
                                    <th scope="col">
                                        <input type="checkbox" onClick={this.handleChange} checked={this.state.select} />
                                    </th>
                                    : null}
                                <th scope="col" style={{ minWidth: '113px' }}>DC No</th>
                                <th scope="col">Project No.</th>
                                <th scope="col">PO No</th>
                                <th scope="col">PO Line Item No</th>
                                <th scope="col" style={{ minWidth: '102px' }}>Issued Qty</th>
                                <th scope="col">Qty Already Dispatched</th>
                                {roles[5] || roles[7] ? <th scope="col">Balance available for Dispatch qty</th> : null}
                                {!roles[5] && !roles[7] ?
                                    <>
                                        <th scope="col">Vendor Name</th>
                                        <th scope="col">Consignee</th>
                                        <th scope="col">Customer BillingSchedule No.</th>
                                        <th scope="col">Customer BillingSchedule Description</th>
                                        <th scope="col">Customer PO</th>
                                        <th scope="col">VendorName</th>
                                        <th scope="col">VendorPONo</th>
                                        <th scope="col">Vendor PO LineItem No</th>
                                        <th scope="col">Customer Billing Schedule Quantity</th>
                                        <th scope="col">UOM</th>
                                        <th scope="col">Remarks</th>
                                    </>
                                    : null}
                                {roles[5] || roles[7] ?
                                    <>
                                        <th scope="col">Present Dispatch</th>
                                        <th scope="col">Remaining</th>
                                        <th scope="col">Total Value</th>
                                    </>
                                    : null}
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.tabledata1.length > 0 ?
                                this.state.tabledata1.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            {roles[5] || roles[7] ?
                                                <td>
                                                    <input type="checkbox"
                                                        checked={this.state.checkedArray.includes(item.DCIssuedId) ? true : false}
                                                        disabled={(item.InvoiceId != null) && (item.AlreadyDispatched == item.IssuedQunatity) ? true : false}
                                                        onChange={() => this.handleSingleCheckBoxChange(item.DCIssuedId)} />
                                                </td>
                                                : null}
                                            <td>
                                                {
                                                    item.DispatchClearenceId != 0 ?
                                                    <a href={FILESERVER_ROOT_URL + "files/Documents/" + item.DocumentId + "/download"} target="_blank" download>
                                                        {item.DispatchClearenceId}
                                                    </a>
                                                    : item.DispatchClearenceId
                                                }
                                                <FontAwesomeIcon className={"ml-2"} icon={"code-branch"} color={"black"} title="Document Version" cursor="pointer" size="lg" onClick={() => this.OpenVersionModal(item.DispatchClearenceId)} />
                                                {AuthHandler.getUserID() == item.ActedId && item.IssuedQunatity != item.AlreadyDispatched ? <FontAwesomeIcon className="ml-2" icon="history" title="Revise" color="blue" cursor="pointer" size="lg" onClick={() => this.modal(item.DispatchClearenceId)} /> : null}
                                            </td>
                                            <td>{item.WBSCode ? item.WBSCode.includes('ET') ? (item.WBSCode).slice(0, 11) : (item.WBSCode).slice(0, 6) : "Other"}</td>
                                            <td>{item.POSAPId}</td>
                                            <td>{item.POServiceLineItemSAPCode}</td>
                                            <td>
                                                {AuthHandler.getUserID() == item.ActedId ?
                                                    <input className='form-control' value={item.IssuedQunatity}
                                                        // disabled={item.IssuedQunatity == item.AlreadyDispatched ? true : false}
                                                        onChange={(e) => this.QuantityChange(e, index, 2)} onBlur={() => this.handleSaveQuantityDetails(item, 1)} />
                                                    : `${item.IssuedQunatity} ${item.OrderUnit}`
                                                }
                                            </td>
                                            <td>{item.AlreadyDispatched + " " + item.OrderUnit}</td>
                                            {roles[5] || roles[7] ? <td>{(item.IssuedQunatity - item.AlreadyDispatched) > 0 ? (item.IssuedQunatity - item.AlreadyDispatched).toFixed(2) : 0 + " " + item.OrderUnit}</td> : null}
                                            {!roles[5] && !roles[7] ?
                                                <>
                                                    <td>{item.POVendorName}</td>
                                                    <td>{item.VendorName}</td>
                                                    <td>
                                                        {AuthHandler.getUserID() == item.ActedId ?
                                                            <input className='form-control' value={item.BillingScheduleNo ? item.BillingScheduleNo : ""} onChange={(e) => this.billhandleChange(e, index, 2)} onBlur={() => this.handleSaveBillingScheduleDetails(item, 2)} />
                                                            :
                                                            <input className='form-control' readOnly value={item.BillingScheduleNo ? item.BillingScheduleNo : ""} />
                                                        }
                                                    </td>
                                                    <td>
                                                        {AuthHandler.getUserID() == item.ActedId ?
                                                            <input className='form-control' value={item.BillScheduleDescription ? item.BillScheduleDescription : ""} onChange={(e) => this.billDeschanldeChange(e, index, 2)} onBlur={() => this.handleSaveBillingScheduleDetails(item, 6)} />
                                                            :
                                                            <input className='form-control' readOnly value={item.BillScheduleDescription ? item.BillScheduleDescription : ""} />
                                                        }
                                                    </td>
                                                    <td>
                                                        {AuthHandler.getUserID() == item.ActedId ?
                                                            <input className='form-control' value={item.Customer_PO ? item.Customer_PO : ""} onChange={(e) => this.handleCustomerPo(e, index, 2)} onBlur={() => this.handleSaveBillingScheduleDetails(item, 9)} />
                                                            :
                                                            <input className='form-control' readOnly value={item.Customer_PO ? item.Customer_PO : ""} />
                                                        }
                                                    </td>
                                                    <td>
                                                        {AuthHandler.getUserID() == item.ActedId ?
                                                            <input className='form-control' value={item.VendorName ? item.VendorName : ""} onChange={(e) => this.handleVendorName(e, index, 2)} onBlur={() => this.handleSaveBillingScheduleDetails(item, 14)} />
                                                            :
                                                            <input className='form-control' readOnly value={item.VendorName ? item.VendorName : ""} />
                                                        }
                                                    </td>
                                                    <td>
                                                        {AuthHandler.getUserID() == item.ActedId ?
                                                            <input className='form-control' value={item.VendorPONo ? item.VendorPONo : ""} onChange={(e) => this.handleVendorPONo(e, index, 2)} onBlur={() => this.handleSaveBillingScheduleDetails(item, 15)} />
                                                            :
                                                            <input className='form-control' readOnly value={item.VendorPONo ? item.VendorPONo : ""} />
                                                        }
                                                    </td>
                                                    <td>
                                                        {AuthHandler.getUserID() == item.ActedId ?
                                                            <input className='form-control' value={item.VendorPO_Line_Item_No ? item.VendorPO_Line_Item_No : ""} onChange={(e) => this.hanldeVendorPOLineItemNo(e, index, 2)} onBlur={() => this.handleSaveBillingScheduleDetails(item, 10)} />
                                                            :
                                                            <input className='form-control' readOnly value={item.VendorPO_Line_Item_No ? item.VendorPO_Line_Item_No : ""} />
                                                        }
                                                    </td>
                                                    <td>
                                                        {AuthHandler.getUserID() == item.ActedId ?
                                                            <input className='form-control' type='number' value={item.Customer_Billing_Schedule_Quantity ? item.Customer_Billing_Schedule_Quantity : ""} onChange={(e) => this.hanldeCustomerBillingScheduleQuantity(e, index, 2)} onBlur={() => this.handleSaveBillingScheduleDetails(item, 11)} />
                                                            :
                                                            <input className='form-control' readOnly value={item.Customer_Billing_Schedule_Quantity ? item.Customer_Billing_Schedule_Quantity : ""} />
                                                        }
                                                    </td>
                                                    <td>
                                                        {AuthHandler.getUserID() == item.ActedId ?
                                                            <input className='form-control' value={item.UOM ? item.UOM : ""} onChange={(e) => this.hanldeUOM(e, index, 2)} onBlur={() => this.handleSaveBillingScheduleDetails(item, 12)} />
                                                            :
                                                            <input className='form-control' readOnly value={item.UOM ? item.UOM : ""} />
                                                        }
                                                    </td>
                                                    <td>
                                                        {AuthHandler.getUserID() == item.ActedId ?
                                                            <input className='form-control' value={item.Remarks ? item.Remarks : ""} onChange={(e) => this.hanldeRemarks(e, index, 2)} onBlur={() => this.handleSaveBillingScheduleDetails(item, 13)} />
                                                            :
                                                            <input className='form-control' readOnly value={item.Remarks ? item.Remarks : ""} />
                                                        }
                                                    </td>
                                                </>
                                                : null}
                                            {roles[5] || roles[7] ?
                                                <>
                                                    <td>
                                                        <input type="number" className="form-control"
                                                            onChange={(e) => this.handlePDCInput(e, index, 2)}
                                                            disabled={(item.IssuedQunatity == item.AlreadyDispatched) && (item.InvoiceId != null) ? true : false}
                                                            value={item.RequestedQuantityForVendors ? item.RequestedQuantityForVendors : 0} />
                                                    </td>
                                                    <td>{((item.IssuedQunatity - item.AlreadyDispatched) - item.RequestedQuantityForVendors) > 0 ? ((item.IssuedQunatity - item.AlreadyDispatched) - item.RequestedQuantityForVendors).toFixed(2) : 0 + " " + item.OrderUnit}</td>
                                                    <td>{item.Currency + " " + (item.NetPrice * item.RequestedQuantityForVendors).toFixed(2)}</td>
                                                </>
                                                : null}
                                        </tr>
                                    )
                                })
                                :
                                this.state.tabledata.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>
                                                <a href={FILESERVER_ROOT_URL + "files/Documents/" + item.DocumentId + "/download"} target="_blank" download>
                                                    {item.DispatchClearenceId}
                                                </a>
                                                <FontAwesomeIcon className={"ml-2"} icon={"code-branch"} color={"black"} title="Document Version" cursor="pointer" size="lg" onClick={() => this.OpenVersionModal(item.DocumentId)} />
                                                {AuthHandler.getUserID() == item.ActedId && item.IssuedQunatity != item.AlreadyDispatched ? <FontAwesomeIcon className="ml-2" icon="history" title="Revise" color="blue" cursor="pointer" size="lg" onClick={() => this.modal(item.DispatchClearenceId)} /> : null}
                                            </td>
                                            <td>{item.WBSCode ? item.WBSCode.includes('ET') ? (item.WBSCode).slice(0, 11) : (item.WBSCode).slice(0, 6) : "Other"}</td>
                                            <td>{item.POSAPId}</td>
                                            <td>{item.POServiceLineItemSAPCode}</td>
                                            <td>
                                                {AuthHandler.getUserID() == item.ActedId ?
                                                    <input className='form-control' value={item.IssuedQunatity}
                                                        //  disabled={item.IssuedQunatity == item.AlreadyDispatched ? true : false}
                                                        onChange={(e) => this.QuantityChange(e, index, 1)} onBlur={() => this.handleSaveQuantityDetails(item, 1)} />
                                                    : `${item.IssuedQunatity} ${item.OrderUnit}`
                                                }
                                            </td>
                                            <td>{item.AlreadyDispatched + " " + item.OrderUnit}</td>
                                            {roles[5] || roles[7] ? <td>{(item.IssuedQunatity - item.AlreadyDispatched) > 0 ? (item.IssuedQunatity - item.AlreadyDispatched).toFixed(2) : 0 + " " + item.OrderUnit}</td> : null}
                                            {!roles[5] && !roles[7] ?
                                                <>
                                                    <td>{item.POVendorName}</td>
                                                    <td>{item.VendorName}</td>
                                                    <td>
                                                        {AuthHandler.getUserID() == item.ActedId ?
                                                            <input className='form-control' value={item.BillingScheduleNo ? item.BillingScheduleNo : ""} onChange={(e) => this.billhandleChange(e, index, 1)} onBlur={() => this.handleSaveBillingScheduleDetails(item, 2)} />
                                                            :
                                                            <input className='form-control' readOnly value={item.BillingScheduleNo ? item.BillingScheduleNo : ""} />
                                                        }
                                                    </td>
                                                    <td>
                                                        {AuthHandler.getUserID() == item.ActedId ?
                                                            <input className='form-control' value={item.BillScheduleDescription ? item.BillScheduleDescription : ""} onChange={(e) => this.billDeschanldeChange(e, index, 1)} onBlur={() => this.handleSaveBillingScheduleDetails(item, 6)} />
                                                            :
                                                            <input className='form-control' readOnly value={item.BillScheduleDescription ? item.BillScheduleDescription : ""} />
                                                        }
                                                    </td>
                                                    <td>
                                                        {AuthHandler.getUserID() == item.ActedId ?
                                                            <input className='form-control' value={item.Customer_PO ? item.Customer_PO : ""} onChange={(e) => this.handleCustomerPo(e, index, 1)} onBlur={() => this.handleSaveBillingScheduleDetails(item, 9)} />
                                                            :
                                                            <input className='form-control'  value={item.Customer_PO ? item.Customer_PO : ""} />
                                                        }
                                                    </td>
                                                    <td>
                                                        {AuthHandler.getUserID() == item.ActedId ?
                                                            <input className='form-control' value={item.VendorName ? item.VendorName : ""} onChange={(e) => this.handleVendorName(e, index, 2)} onBlur={() => this.handleSaveBillingScheduleDetails(item, 14)} />
                                                            :
                                                            <input className='form-control' readOnly value={item.VendorName ? item.VendorName : ""} />
                                                        }
                                                    </td>
                                                    <td>
                                                        {AuthHandler.getUserID() == item.ActedId ?
                                                            <input className='form-control' value={item.VendorPONo ? item.VendorPONo : ""} onChange={(e) => this.handleVendorPONo(e, index, 2)} onBlur={() => this.handleSaveBillingScheduleDetails(item, 15)} />
                                                            :
                                                            <input className='form-control' readOnly value={item.VendorPONo ? item.VendorPONo : ""} />
                                                        }
                                                    </td>
                                                    <td>
                                                        {AuthHandler.getUserID() == item.ActedId ?
                                                            <input className='form-control' value={item.VendorPO_Line_Item_No ? item.VendorPO_Line_Item_No : ""} onChange={(e) => this.hanldeVendorPOLineItemNo(e, index, 1)} onBlur={() => this.handleSaveBillingScheduleDetails(item, 10)} />
                                                            :
                                                            <input className='form-control'  value={item.VendorPO_Line_Item_No ? item.VendorPO_Line_Item_No : ""} />
                                                        }
                                                    </td>
                                                    <td>
                                                        {AuthHandler.getUserID() == item.ActedId ?
                                                            <input className='form-control' type='number' value={item.Customer_Billing_Schedule_Quantity ? item.Customer_Billing_Schedule_Quantity : ""} onChange={(e) => this.hanldeCustomerBillingScheduleQuantity(e, index, 1)} onBlur={() => this.handleSaveBillingScheduleDetails(item, 11)} />
                                                            :
                                                            <input className='form-control'  value={item.Customer_Billing_Schedule_Quantity ? item.Customer_Billing_Schedule_Quantity : ""} />
                                                        }
                                                    </td>
                                                    <td>
                                                        {AuthHandler.getUserID() == item.ActedId ?
                                                            <input className='form-control' value={item.UOM ? item.UOM : ""} onChange={(e) => this.hanldeUOM(e, index, 1)} onBlur={() => this.handleSaveBillingScheduleDetails(item, 12)} />
                                                            :
                                                            <input className='form-control'  value={item.UOM ? item.UOM : ""} />
                                                        }
                                                    </td>
                                                    <td>
                                                        {AuthHandler.getUserID() == item.ActedId ?
                                                            <input className='form-control' value={item.Remarks ? item.Remarks : ""} onChange={(e) => this.hanldeRemarks(e, index, 1)} onBlur={() => this.handleSaveBillingScheduleDetails(item, 13)} />
                                                            :
                                                            <input className='form-control'  value={item.Remarks ? item.Remarks : ""} />
                                                        }
                                                    </td>
                                                </>
                                                : null}
                                            {roles[5] || roles[7] ?
                                                <>
                                                    <td>
                                                        <input type="number" className="form-control"
                                                            readOnly
                                                            value={item.RequestedQuantityForVendors ? item.RequestedQuantityForVendors : 0} />
                                                    </td>
                                                    <td>{((item.IssuedQunatity - item.AlreadyDispatched) - item.RequestedQuantityForVendors) > 0 ? ((item.IssuedQunatity - item.AlreadyDispatched) - item.RequestedQuantityForVendors).toFixed(2) : 0 + " " + item.OrderUnit}</td>
                                                    <td>{item.Currency + " " + (item.NetPrice * item.RequestedQuantityForVendors).toFixed(2)}</td>
                                                </>
                                                : null}
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => ({ dispatchOrderDetailsReducer: state.dispatchOrderDetailsReducer, file: state.file, filterList: state.masterReducer.filterList, poDetails: state.poDetails, })
export default connect(mapStateToProps, { GetPOAndLineItemListForDispatchForDCListing, postDispatchClearenceDetails, postSubmitInvoiceDetails, GenericUploadVersionFile, GetFilterList, getProjectAllocationByUserId })(DispatchVendorDocumentSubmission)
